module.exports = __webpack_public_path__ + "static/media/FeedbackBot.063691a7.png";